<template>
  <div
    v-if="componentReady"
    class="diagnostics-container"
  >
    <b-row>
      <b-col cols="12">
        <h3>
          BETS-e App Diagnostics
        </h3>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-table
          striped
          hover
          bordered
          head-variant="light"
          id="diagnostics-list"
          class="diagnostics-list clickable-item-list"
          :items="diagnostics"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :show-empty="true"
          empty-text="There are no diagnostics to display."
          :tbody-tr-class="isSeen"
          @row-clicked="viewDiagnostics"
        >
          <template v-slot:cell(branch)="data">
            {{ getBranchName(data) }}
          </template>

          <template v-slot:cell(user)="data">
            {{ getBFMName(data) }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        Showing {{ currentViewCount }} of {{ totalCount }}
      </b-col>
      <b-col cols="6">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          align="center"
          aria-controls="user-list"
          v-show="hasPages"
        />
      </b-col>
      <b-col cols="3">
        <b-form-select
          v-if="totalCount > perPage"
          class="filter-option"
          :options="pageOptions"
          v-model="perPage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  middleware: 'auth',
  name: 'Diagnostics',
  data () {
    return {
      componentReady: '',
      currentPage: 1,
      page: 1,
      perPage: 10,
      totalNumberRowsAvailable: 0,
      totalCount: 0,
      pageOptions: [
        {
          value: 10,
          text: '10 per page'
        },
        {
          value: 20,
          text: '20 per page'
        },
        {
          value: 30,
          text: '30 per page'
        },
        {
          value: 100,
          text: '100 per page'
        }
      ],
      fields: [
        {
          branch: {
            label: 'BFM',
            class: ['branch-name']

          }
        },
        {
          user: {
            label: 'BFM',
            class: ['user']
          }
        },
        {
          key: 'created_at',
          sortable: true,
          class: ['created']
        }
      ]
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapGetters({
      diagnostics: 'support/diagnostics'
    }),
    totalRows: {
      get () {
        return this.totalNumberRowsAvailable + (this.totalCount - this.totalNumberRowsAvailable)
      },
      set (value) {
        this.totalNumberRowsAvailable = value
      }
    },
    hasPages () {
      return this.diagnostics.length > this.perPage
    },
    numberPages () {
      return this.diagnostics.length / this.perPage
    },
    currentViewCount () {
      let showing = this.perPage * this.currentPage
      if (showing > this.totalRows) {
        showing = this.totalRows
      }
      return (this.totalCount >= this.perPage) ? showing : this.totalCount
    }
  },
  methods: {
    ...mapActions({
      getDiagnostics: 'support/getDiagnostics'
    }),
    async init () {
      await this.getDiagnostics()
      this.totalRows = this.diagnostics.length
      this.totalCount = this.diagnostics.length
      this.componentReady = true
    },
    viewDiagnostics (meta) {
      this.$router.push({ name: 'diagnostics-view', params: { id: meta.id.toString() } })
    },
    getBFMName (data) {
      return data.item.bundle.user.name
    },
    getBranchName (data) {
      return data.item.bundle.user.branchName
    },
    isSeen (data) {
      const classes = []
      classes.push('diagnostic')
      if (data && data.seen !== null && data.seen !== undefined && data.seen) {
        classes.push('seen')
      }
      return classes
    }
  }
}
</script>

<style scoped lang="scss">
.clickable-item-list {
  cursor: pointer;
}
</style>
